/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ModalRoute } from 'react-router-modal';
import './bookingDetails.scss';
import './BookingDetailsChargesWidget.scss';
import * as api from '../../../../epics/api';

import history from '../../../../history';

const propTypes = {
    job: PropTypes.object.isRequired,
    notification: PropTypes.object.isRequired,
    table: PropTypes.object.isRequired,
};

class BookingDetailsChargesWidget extends Component {
    constructor() {
        super();
        this.state = {
            charges: { meta: null, content: [] },
            addCharges: [],
            isPosting: false,
            editingExistingBookingChargeID: null,
            deletingExistingBookingChargeID: null,
            editingExistingBookingChargeFields: {},
        };
    }

    componentDidMount() {
        this.fetchCharges();
    }

    closeModal = () => {
        const pathname = this.props.location.pathname.replace('/charges/', '/');
        history.push(pathname + this.props.location.search);
    };

    fetchCharges = () =>
        api
            .executeHttpRequest(
                `jobs/${this.props.relevantJobId}/bookings/${this.props.job.booking.id}/charges/`,
            )
            .then(res => {
                this.setState({
                    charges: { meta: res.data.meta, content: res.data.content },
                });
            });

    resetAddCharges = () => {
        this.setState({ addCharges: [] });
    };

    isPosting(status = true) {
        this.setState({ isPosting: status });
    }

    addChargeRow = (label = '', client_amount = 0, freelancer_amount = 0) =>
        this.setState({
            addCharges: [
                ...this.state.addCharges,
                {
                    label,
                    client_amount,
                    freelancer_amount,
                },
            ],
        });

    handleRemoveAddChargeRow = idx => {
        this.setState({
            addCharges: this.state.addCharges.filter(
                (addChargeRow, addChargeRowIndex) => idx !== addChargeRowIndex,
            ),
        });
    };

    handleAddChargeFieldChange = (idx, fieldName) => evt => {
        const newAddCharges = this.state.addCharges.map((addCharge, sidx) => {
            if (idx !== sidx) return addCharge;
            if (fieldName == 'client_amount') {
                return { ...addCharge, client_amount: evt.target.value };
            }
            if (fieldName == 'freelancer_amount') {
                return { ...addCharge, freelancer_amount: evt.target.value };
            }
            return { ...addCharge, label: evt.target.value };
        });

        this.setState({ addCharges: newAddCharges });
    };

    handleAddChargeSaveButton = () => {
        const postData = this.state.addCharges
            .filter(
                charge =>
                    charge.label != '' &&
                    charge.client_amount >= 0 &&
                    charge.freelancer_amount >= 0,
            )
            .map(charge => ({
                ...charge,
                booking: this.props.job.booking.id,
            }));
        this.isPosting(true);
        return api
            .executeHttpRequest(
                `jobs/${this.props.relevantJobId}/bookings/${this.props.job.booking.id}/charges/`,
                'post',
                postData,
            )
            .then(res => {
                this.isPosting(false);
                this.fetchCharges().then(() => {
                    this.resetAddCharges();
                    this.props.table.table.fireFetchData();
                });
            });
    };

    handleRemoveExistingBookingCharge = charge => {
        this.setState({ deletingExistingBookingChargeID: charge.id });
        this.isPosting(true);
        return api
            .executeHttpRequest(
                `jobs/${this.props.relevantJobId}/bookings/${this.props.job.booking.id}/charges/${charge.id}`,
                'delete',
            )
            .then(res => {
                this.isPosting(false);
                this.fetchCharges().then(() => {
                    this.resetAddCharges();
                    this.props.table.table.fireFetchData();
                });
            });
    };

    handleEditExistingBookingChargeButton = charge => {
        this.setState({
            editingExistingBookingChargeID: charge.id,
            editingExistingBookingChargeFields: { ...charge },
        });
    };

    handleEditExistingBookingChargeCancelButton = () => {
        this.setState({
            editingExistingBookingChargeID: null,
            editingExistingBookingChargeFields: {},
        });
    };

    handleEditExistingBookingChargeFieldChange = fieldName => evt => {
        this.setState({
            editingExistingBookingChargeFields: {
                ...this.state.editingExistingBookingChargeFields,
                [fieldName]: evt.target.value,
            },
        });
    };

    handleEditExistingBookingChargeSaveButton = () => {
        this.isPosting(true);
        return api
            .executeHttpRequest(
                `jobs/${this.props.relevantJobId}/bookings/${this.props.job.booking.id}/charges/${this.state.editingExistingBookingChargeFields.id}/`,
                'patch',
                this.state.editingExistingBookingChargeFields,
            )
            .then(res => {
                this.isPosting(false);
                this.fetchCharges().then(() => {
                    this.handleEditExistingBookingChargeCancelButton();
                    this.props.table.table.fireFetchData();
                });
            });
    };

    renderExistingChargesActionButtons(charge) {
        if (this.state.editingExistingBookingChargeID == charge.id) {
            return (
                <td className="actions center">
                    <button
                        onClick={() =>
                            this.handleEditExistingBookingChargeSaveButton()
                        }
                    >
                        <i className="icon icon icon-check-12 cursor-pointer" />
                    </button>
                    <button
                        onClick={() =>
                            this.handleEditExistingBookingChargeCancelButton()
                        }
                    >
                        <i className="icon icon-close2 cursor-pointer" />
                    </button>
                </td>
            );
        }
        return (
            <td className="actions center">
                <button
                    onClick={() =>
                        this.handleEditExistingBookingChargeButton(charge)
                    }
                >
                    <i className="icon icon-pencil-3 cursor-pointer" />
                </button>
                <button
                    disabled={
                        this.state.deletingExistingBookingChargeID == charge.id
                    }
                    onClick={() =>
                        this.handleRemoveExistingBookingCharge(charge)
                    }
                >
                    <i className="icon icon-bin-1 cursor-pointer" />
                </button>
            </td>
        );
    }

    renderExistingChargesRow() {
        return this.state.charges.content.map(charge => {
            if (this.state.editingExistingBookingChargeID == charge.id) {
                return (
                    <tr key={`editing-charge-${charge.id}`}>
                        <td>
                            <input
                                type="text"
                                value={
                                    this.state
                                        .editingExistingBookingChargeFields
                                        .label
                                }
                                onChange={this.handleEditExistingBookingChargeFieldChange(
                                    'label',
                                )}
                            />
                        </td>
                        <td>
                            £{' '}
                            <input
                                value={
                                    this.state
                                        .editingExistingBookingChargeFields
                                        .client_amount
                                }
                                type="number"
                                step={0.05}
                                min={0}
                                onChange={this.handleEditExistingBookingChargeFieldChange(
                                    'client_amount',
                                )}
                            />
                        </td>
                        <td>
                            £{' '}
                            <input
                                value={
                                    this.state
                                        .editingExistingBookingChargeFields
                                        .freelancer_amount
                                }
                                type="number"
                                step={0.05}
                                min={0}
                                onChange={this.handleEditExistingBookingChargeFieldChange(
                                    'freelancer_amount',
                                )}
                            />
                        </td>
                        {this.renderExistingChargesActionButtons(charge)}
                    </tr>
                );
            }
            return (
                <tr key={`charge-${charge.id}`}>
                    <td>{charge.label}</td>
                    <td>£{charge.client_amount}</td>
                    <td>£{charge.freelancer_amount}</td>
                    {this.renderExistingChargesActionButtons(charge)}
                </tr>
            );
        });
    }

    renderAddChargesRow() {
        return this.state.addCharges.map((addCharge, index) => (
            <tr key={`add-charge-${index}`}>
                <td>
                    <input
                        type="text"
                        value={addCharge.label}
                        onChange={this.handleAddChargeFieldChange(
                            index,
                            'label',
                        )}
                    />
                </td>
                <td>
                    £{' '}
                    <input
                        value={addCharge.client_amount}
                        type="number"
                        step={0.05}
                        min={0}
                        onChange={this.handleAddChargeFieldChange(
                            index,
                            'client_amount',
                        )}
                    />
                </td>
                <td>
                    £{' '}
                    <input
                        value={addCharge.freelancer_amount}
                        type="number"
                        step={0.05}
                        min={0}
                        onChange={this.handleAddChargeFieldChange(
                            index,
                            'freelancer_amount',
                        )}
                    />
                </td>
                <td className="actions center">
                    <button
                        onClick={() => this.handleRemoveAddChargeRow(index)}
                    >
                        <i className="icon icon-bin-1 cursor-pointer" />
                    </button>
                </td>
            </tr>
        ));
    }

    render() {
        return (
            <div className="booking-details booking-details-charges-modal">
                <div className="header-section">
                    <div className="title">
                        Charges for {this.props.job.booking.reference_number}
                    </div>
                    <div
                        className="header-dismiss"
                        onClick={() => this.closeModal()}
                    >
                        <i className="icon icon-close" />
                    </div>
                </div>
                <div className="content-section">
                    <table className="table-default">
                        <tbody>
                            <tr>
                                <td className="table-default__cell--text-blue">
                                    Label
                                </td>
                                <td className="table-default__cell--text-blue">
                                    Client amount
                                </td>
                                <td className="table-default__cell--text-blue">
                                    Freelancer amount
                                </td>
                                <td className="table-default__cell--text-blue center">
                                    <i className="icon icon-cog" />
                                </td>
                            </tr>
                            {this.renderExistingChargesRow()}
                            {this.renderAddChargesRow()}
                        </tbody>
                    </table>

                    <div className="add-row">
                        <p
                            onClick={() =>
                                this.addChargeRow('Congestion', 11.5, 11.5)
                            }
                        >
                            <i className="icon congestion-icon" /> Add
                            congestion charge
                        </p>
                        <p onClick={() => this.addChargeRow()}>
                            <i className="icon icon-add-12" /> Add another
                            charge
                        </p>
                    </div>

                    <div className="btns">
                        {this.state.isPosting ? (
                            <i className="icon icon-loading-1 font-size-30" />
                        ) : null}

                        <button
                            disabled={this.state.isPosting}
                            onClick={() => this.handleAddChargeSaveButton()}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

BookingDetailsChargesWidget.propTypes = propTypes;

export default BookingDetailsChargesWidget;
